import {useReversalService} from '../../service/reversal/index'

const useEndCase= () => {
    const {endCaseById} = useReversalService()
  const endCaseByIdHooks = async (data: any) => {
    const res = await endCaseById(data)
    return res
  };
  return {
    endCaseByIdHooks,
  };
};

export default useEndCase;
